import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
} from "react";
const initial = {
  run: false,
  stepIndex: 0,
  steps: [],
  tourActive: false,
  tourTitle: "",
};
const TourGuidStartContext = createContext();
const TourGuidStartActionsContext = createContext();
const TourGuidStoryTrackerContext = createContext();
const TourGuidStoryTrackerActionsContext = createContext();
const TourGuidConfigContext = createContext(initial);
const TourGuidConfigActionsContext = createContext();
const TourGuidSavedSettingContext = createContext();
const TourGuidSavedSettingActionsContext = createContext();

export const useTourGuidSavedSettingContext = () =>
  useContext(TourGuidSavedSettingContext);
export const useTourGuidSavedSettingActionsContext = () =>
  useContext(TourGuidSavedSettingActionsContext);

export const useTourGuidStartContext = () => useContext(TourGuidStartContext);
export const useTourGuidStartActionsContext = () =>
  useContext(TourGuidStartActionsContext);

export const useTourGuidStoryTrackerContext = () =>
  useContext(TourGuidStoryTrackerContext);
export const useTourGuidStoryTrackerActionsContext = () =>
  useContext(TourGuidStoryTrackerActionsContext);

export const useTourGuidConfigContext = () => useContext(TourGuidConfigContext);
export const useTourGuidConfigActionsContext = () =>
  useContext(TourGuidConfigActionsContext);

export const TourGuidProvider = ({ children }) => {
  const [startTour, setStartTour] = React.useState({
    tourTitle: "",
    tourStatus: false,
    anyStep: 0,
  });
  const [tourStoryTracker, setTourStoryTracker] = React.useState("WelcomeTour");
  const [guideTourstate, setGuideTourState] = React.useState(initial);
  const [tourGuidSaveSetting, setTourGuidSaveSetting] = React.useState([]);
  const UpdateTourStatus = useCallback((_value) => {
    setStartTour((prev) => ({
      tourTitle: _value.tourTitle,
      tourStatus: _value.tourStatus,
      anyStep: _value.anyStep,
      lastIndexKey: _value.lastIndexKey,
      firstIndexKey: _value.firstIndexKey,
    }));
  }, []);

  const UpdateTourStoryTracker = (_value) => {
    setTourStoryTracker((prev) => _value);
  };

  const UpdateGuideTourState = () => {};
  return (
    <TourGuidStartContext.Provider value={startTour}>
      <TourGuidStartActionsContext.Provider value={UpdateTourStatus}>
        <TourGuidStoryTrackerContext.Provider value={tourStoryTracker}>
          <TourGuidStoryTrackerActionsContext.Provider
            value={UpdateTourStoryTracker}
          >
            <TourGuidConfigContext.Provider value={guideTourstate}>
              <TourGuidConfigActionsContext.Provider value={setGuideTourState}>
                <TourGuidSavedSettingActionsContext.Provider
                  value={setTourGuidSaveSetting}
                >
                  <TourGuidSavedSettingContext.Provider
                    value={tourGuidSaveSetting}
                  >
                    {" "}
                    {children}
                  </TourGuidSavedSettingContext.Provider>
                </TourGuidSavedSettingActionsContext.Provider>
              </TourGuidConfigActionsContext.Provider>
            </TourGuidConfigContext.Provider>
          </TourGuidStoryTrackerActionsContext.Provider>
        </TourGuidStoryTrackerContext.Provider>
      </TourGuidStartActionsContext.Provider>
    </TourGuidStartContext.Provider>
  );
};
